import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const ColumnsByTableIdFragmentGql: DocumentNode = gql`
fragment ColumnsByTableIdFragment on Column {
  id
  name
  remoteType
  description
  downstreamSheetsConnection {
    totalCount
  }
  downstreamDatasourcesConnection {
    totalCount
  }
  downstreamWorkbooksConnection {
    totalCount
  }
}
`;

export const TableColumnsByIdQueryGql: DocumentNode = gql`
query TableColumnsByIdQuery($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: ColumnSortOrder!) {
  tablesConnection(filter: { id: $tableId }) {
    nodes {
      id
      name
      ... on DatabaseTable {
        schema
      }
      columnsConnection( first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          tags {
            name
          }
          ...ColumnsByTableIdFragment
        }
      }
    }
  }
}
${ColumnsByTableIdFragmentGql}
`;
